// Maps Auth0 Org ID → domainKey
const ORG_ID_TO_DOMAIN_KEY = {
  production: {
    83: 'iimbaa',
  },
  test: {
    308: 'iimbaa',
  },
};

const DOMAIN_PREFIX_REDIRECTS = {
  'iimbaa.neki.app': 'https://iimbaa.com/account',
  'iimbaa.neki.io': 'https://iimbaa.com/account',
};

// Static config for each domainKey
const BASE_CONFIG_BY_DOMAIN = {
  iimbaa: {
    domainKey: 'iimbaa',
  },
};

// Set environment
const isProduction = process.env.NEXT_PUBLIC_NEKI_ENV === 'production';
const ENV = isProduction ? 'production' : 'test';

// Domain-specific values (env-dependent)
const ENV_DOMAIN_CONFIG = {
  iimbaa: {
    domain: isProduction ? 'iimba.neki.io' : 'iimba.neki.app',
    clientUrl: isProduction ? 'https://iimbaa.neki.io' : 'https://iimbaa.neki.app',
    loginUrl: 'https://iimbaa.com/account',
    communityId: isProduction ? 308 : 83,
    locationId: isProduction ? 90 : 335,
  },
};

/**
 * Merge base + env config for a domainKey
 */
function resolveOrgConfig(domainKey) {
  const base = BASE_CONFIG_BY_DOMAIN[domainKey];
  const env = ENV_DOMAIN_CONFIG[domainKey];
  if (!base || !env) {
    throw new Error(`Invalid domainKey: "${domainKey}"`);
  }
  return { ...base, ...env };
}

/**
 * Builds org config and reverse domainKey mapping
 */
function buildConfigs(orgIdToDomainKeyMap) {
  const orgConfig = {};
  const domainKeyToOrgId = {};

  for (const [orgId, domainKey] of Object.entries(orgIdToDomainKeyMap)) {
    orgConfig[domainKey] = resolveOrgConfig(domainKey);
    domainKeyToOrgId[domainKey] = orgId;
  }

  return { orgConfig, domainKeyToOrgId };
}

// Active org mapping and derived configs
const orgIds = ORG_ID_TO_DOMAIN_KEY[ENV]; // Auth0 Org ID → domainKey
const { orgConfig, domainKeyToOrgId } = buildConfigs(orgIds);

export {
  orgIds, // Auth0 Org ID → domainKey
  orgConfig, // Auth0 Org ID → full config
  domainKeyToOrgId, // domainKey → Auth0 Org ID
  DOMAIN_PREFIX_REDIRECTS,
};
